import { en, Translations } from './en';
import { pl } from './pl';

const STORAGE_KEY = 'app-language';

export const AVAILABLE_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'pl', label: 'Polski' },
] as const;

const translations: Record<string, Translations> = {
  en,
  pl,
};

function detectLanguage(): string {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && translations[stored]) {
    return stored;
  }
  const browserLang = navigator.language;
  return browserLang.startsWith('pl') ? 'pl' : 'en';
}

let currentLang = detectLanguage();

export function setLanguage(lang: string): void {
  if (translations[lang]) {
    currentLang = lang;
    localStorage.setItem(STORAGE_KEY, lang);
  }
}

export function getLanguage(): string {
  return currentLang;
}

// Helper to get nested value from object using dot notation
function getNestedValue(obj: Record<string, unknown>, path: string): string {
  const keys = path.split('.');
  let current: unknown = obj;

  for (const key of keys) {
    if (current && typeof current === 'object' && key in current) {
      current = (current as Record<string, unknown>)[key];
    } else {
      return path; // Return the key if not found
    }
  }

  return typeof current === 'string' ? current : path;
}

// Translation function
export function t(key: string, params?: Record<string, string | number>): string {
  const translation = getNestedValue(
    translations[currentLang] as unknown as Record<string, unknown>,
    key,
  );

  if (!params) {
    return translation;
  }

  // Replace placeholders like {name} with values from params
  return translation.replace(
    /\{(\w+)\}/g,
    (_, paramName) => String(params[paramName] ?? `{${paramName}}`),
  );
}

// Re-export translations for type safety
export { en };
export type { Translations };
